import { useState } from 'react';
import styled from 'styled-components';
import { Loading, FlexColumn } from '@elementary/common-ui/components';
import { space } from '@elementary/common-ui/style/utils';
import { useGroups } from '../hooks/useGroups';
import Header from './Header';
import GroupsTable from './GroupsTable';

const Wrapper = styled(FlexColumn)`
  height: 100%;
  width: 100%;
  gap: ${space('xxl')};
`;

const Groups = () => {
  const [search, setSearch] = useState('');
  const { groups, isLoading, deleteGroupAsync, isDeleting } = useGroups();

  return isLoading ? (
    <Loading />
  ) : (
    <Wrapper>
      <Header search={search} onSearchChange={setSearch} />

      <GroupsTable
        groups={groups}
        search={search}
        onDeleteGroup={deleteGroupAsync}
        isDeleting={isDeleting}
      />
    </Wrapper>
  );
};

export default Groups;
